import React, { useEffect, useState, useRef } from 'react';
import { Form } from 'react-bootstrap';
import Loader from '../loader/loader'
import './register.css'
import useToastNotification from '../../hooks/useToastNotification';
import { checkMobile, Register, loginApi } from '../../utils/api'
import { Dialog } from 'primereact/dialog';
import Logo from '../../assets/images/LOGO.png';

import Eye from '../../assets/icons/eye.svg'
import HideEye from '../../assets/icons/close-eye.svg'
const Login = () => {
    const [otpCode, setOtpCode] = useState('');
    const [mobile, setMobile] = useState('');
    const [fullName, setFullName] = useState('');
    const [userName, setUserName] = useState('');
    const [email, setEmail] = useState('');
    const [otpSend, setOptSend] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [acceptedTerms, setAcceptedTerms] = useState(true);
    const [validated, setValidated] = useState(false);
    const [loader, setLoginLoader] = useState(false);
    const [otpVisible, setOtpVisible] = useState(false);
    const { showError, showSuccess } = useToastNotification();
    const [typePassword, setTypePassword] = useState('password');
    const [time, setTime] = useState(120); // Initialize with 2 minutes (120 seconds)
    const [isActive, setIsActive] = useState(false);
    const [resendBtn, setResendBtn] = useState(true);
    const [resendCode, setResendCode] = useState(false);
    const [checkOtpLoading, setCheckOtpLoading] = useState(false);
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const inputRefs = useRef([]);

    const handleOtpChange = (index, value) => {
        if (value.length <= 1) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            if (value && index < otp.length - 1) {
                inputRefs.current[index + 1].focus();
            }
        }
    };

    const [selectedType, setSelectedType] = useState("B"); // State for selected value

    const handleChange = (e) => {
        setSelectedType(e.target.value); // Update state when a radio button is clicked
    };


    const checkMobileFun = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        console.log('.....')
        // Set interval for timer


        if (form.checkValidity() === true) {
            if (mobile == '' || !mobile.startsWith('09') || mobile.length != 11) {
                showError('لطفا شماره همراه را به صورت صحیح وارد کنید.')
                return
            }
            if (otpCode == '') {
                showError('لطفا رمز عبور خود را وارد کنید.')
                return
            }
            // if (!acceptedTerms) {
            //     showError('لطفا قوانین و مفرارت را تایید کنید.')
            //     return
            // }
            event.stopPropagation();
            setOtpVisible(true)
            setOtp(["", "", "", "", "", ""])

            try {
                setLoginLoader(true);
                let response = await checkMobile(mobile);

                if (response.data.res === 'OK') {

                    setIsActive(true);
                    setLoginLoader(false);
                    console.log(response.data.resTp)
                    setOptSend(response.data.resTp)
                    setResendCode(false);
                    setTime(120);
                    showSuccess('کد با موفقیت ارسال شد');

                } else if (response.data.res === 'NotOK') {
                    setLoginLoader(false);

                    let error = {
                        title: 'اخطار',
                        text: response.data.resTp,
                    };
                    showError(error);
                }
            } catch (error) {
                setLoginLoader(false);
                console.log(error);
            }
        }

        setValidated(true);
    };

    const showPassword = () => {
        setTypePassword('text')
    }
    const hidePassword = () => {
        setTypePassword('password')
    }


    //setTimer
    useEffect(() => {
        let timerId;
        if (isActive && time > 0) {
            timerId = setInterval(() => {
                setTime(prevTime => prevTime - 1);
            }, 1000);
        } else if (time === 0) {
            onTimerFinish(); // Call the function when the timer reaches 0
        }
        // Cleanup interval on component unmount or when time reaches 0
        return () => clearInterval(timerId);
    }, [isActive, time]);

    //finishTimer
    const onTimerFinish = () => {
        setResendCode(true);
        setResendBtn(false);
    }

    const formatTime = (time) => {
        const minutes = String(Math.floor(time / 60)).padStart(2, '0');
        const seconds = String(time % 60).padStart(2, '0');
        return `${minutes}:${seconds}`;
    }

    const getOtpValue = () => otp.join("");

    const checkOtp = async () => {
        console.log(getOtpValue())
        let codeOtp = getOtpValue()
        // if (parseInt(getOtpValue()) == parseInt(otpSend)) {
        try {
            setCheckOtpLoading(true)
            let pay = {
                mahiyat: selectedType,
                pass: otpCode,
                loginName: userName,
                email: email,
                phone: phoneNumber,
                mobile: mobile,
                fullName: fullName,
                code: codeOtp
            }
            console.log(pay)
            let res = await Register(pay)
            if (res.data.res == 'OK') {
                setCheckOtpLoading(false)
                setOtpVisible(false)
                showSuccess('ثبت نام با موفقیت انجام شد')
                login()
            }
            else {
                setCheckOtpLoading(false)
                // setOtpVisible(false)
                showError(res.data.resTp)
            }
        } catch (error) {
            setCheckOtpLoading(false)
        }
        // }

    }


    //login
    const login = async (event, pass) => {
        let codeOtp = getOtpValue()
        let ipAddress = await getIPAddress();
        let payload = {
            ip: ipAddress,
            mobile: mobile,
            password: codeOtp
        }
        try {
            let loginRes = await loginApi(payload)
            if (loginRes && loginRes.data.res === 'OK') {
                //save customerInfo in localStorage
                window.localStorage.setItem('userInfo', JSON.stringify(loginRes.data))
                window.location.href = `/`;

            } else {
                let error = {
                    // title: loginRes.data.fullName,
                    text: loginRes.data.resTp,
                }
                showError(error);
            }
        } catch (error) {
        }


    }


    //get IPAddress for login
    const getIPAddress = async () => {
        try {
            const response = await fetch('https://api.ipify.org?format=json');
            const data = await response.json();
            return data.ip;
        } catch (error) {
            console.error('Failed to fetch IP address:', error);
            return null;
        }
    }


    return (
        <>
            <h2 className='text-xl font-bold mt-4 text-right text-[#242526]'>ورود به حساب کاربری فروش عمده</h2>

            <div className='d-flex align-center gap-2 mt-2'>
                <Form.Check
                    inline
                    label="حقیقی"
                    name="group1"
                    type="radio"
                    value="B" // Setting value
                    checked={selectedType === "B"} // Checking if selected
                    onChange={handleChange} // Handling change
                />
                <Form.Check
                    inline
                    label="حقوقی"
                    name="group1"
                    type="radio"
                    value="C" // Setting value
                    checked={selectedType === "C"} // Checking if selected
                    onChange={handleChange} // Handling change
                />
            </div>
            {!otpVisible && (
                <Form className='login-form mt-2 row gy-2' noValidate validated={validated} onSubmit={(e) => checkMobileFun(e)}>
                    {selectedType === "C" ? (
                        <>
                            <Form.Group controlId="fullName" className=' col-12 col-md-6'>
                                <Form.Label className="text-sm text-[#242526]"> نام مجموعه <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={fullName}
                                    onChange={(e) => setFullName(e.target.value)}
                                    required
                                />
                                <Form.Control.Feedback type="invalid">
                                    نام مجموعه را وارد کنید
                                </Form.Control.Feedback>
                            </Form.Group>
                        </>
                    ) : (
                        <>
                            <Form.Group controlId="fullName" className=' col-12 col-md-6'>
                                <Form.Label className="text-sm text-[#242526]"> نام و نام خانوادگی <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={fullName}
                                    onChange={(e) => setFullName(e.target.value)}
                                    required
                                />
                                <Form.Control.Feedback type="invalid">
                                    نام و نام خانوادگی را وارد کنید
                                </Form.Control.Feedback>
                            </Form.Group>
                        </>

                    )}

                    <Form.Group controlId="userName" className=' col-12 col-md-6'>
                        <Form.Label className="text-sm text-[#242526]"> نام کاربری <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            type="text"
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            نام کاربری را وارد کنید
                        </Form.Control.Feedback>
                    </Form.Group>
                    {
                        selectedType === "C" && (
                            <>
                                {/* نام کاربری / شماره موبایل */}
                                <Form.Group controlId="phoneNumber" className=' col-12 col-md-6'>
                                    <Form.Label className="text-sm text-[#242526]"> شماره ثابت <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="number"
                                        inputMode="numeric"
                                        value={phoneNumber}
                                        onChange={(e) => setPhoneNumber(e.target.value)}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        شماره ثابت را وارد کنید
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </>
                        )
                    }
                    {/* نام کاربری / شماره موبایل */}
                    <Form.Group controlId="mobile" className=' col-12 col-md-6'>
                        <Form.Label className="text-sm text-[#242526]"> شماره همراه <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            type="number"
                            inputMode="numeric"
                            value={mobile}
                            onChange={(e) => setMobile(e.target.value)}
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            شماره همراه را وارد کنید
                        </Form.Control.Feedback>
                    </Form.Group>
                    {/* رمز عبور / کد تایید */}
                    <Form.Group controlId="otpCode" className="col-12 col-md-6 ">
                        <Form.Label className="text-sm text-[#242526]">رمز عبور <span className="text-danger">*</span></Form.Label>
                        <div className='input-icon pl-2'>
                            <Form.Control type={typePassword} value={otpCode} onChange={(e) => setOtpCode(e.target.value)} />
                            {typePassword === 'password' ? <img src={Eye} alt="" onClick={showPassword} /> : <img src={HideEye} alt="" onClick={hidePassword} />}
                        </div>

                    </Form.Group>

                    <Form.Group controlId="email" className=' col-12 col-md-6'>
                        <Form.Label className="text-sm text-[#242526]"> ایمیل</Form.Label>
                        <Form.Control
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </Form.Group>



                    {/* شرایط و قوانین */}
                    {/* <Form.Check

                        className="mt-3 text-sm text-[#242526]"
                        label="شرایط و قوانین را قبول دارم."
                        type="checkbox"
                        checked={acceptedTerms}
                        onChange={(e) => setAcceptedTerms(e.target.checked)}
                    /> */}



                    {/* دکمه تأیید */}
                    <div className=' col-12'>

                        <button
                            type="submit"
                            disabled={loader}
                            className="btn btn-primary col-12 mx-auto mt-3 d-flex align-items-center gap-2 justify-center"
                        >
                            ادامه {loader && <Loader />}
                        </button>
                    </div>


                </Form>
            )

            }




            <Dialog
                draggable={false}
                dismissableMask
                visible={otpVisible}
                style={{ width: '40vw' }}
                breakpoints={{ '60vw': '60vw', '80vw': '90vw' }}
                onHide={() => setOtpVisible(false)}
                className='login-dialog'
            >

                <div className='text-center'>
                    <img src={Logo} alt="" className='mx-auto' width={96} />
                </div>

                <p className='text-center mt-5'>لطفا کد ارسال شده به شماره {mobile} را وارد کنید.</p>

                <button className='btn border-0  w-100 text-left px-5' onClick={() => setOtpVisible(false)} style={{ color: '#00a14b', textAlign: 'left' }}>تغییر شماره موبایل</button>
                <div className="d-flex justify-content-center gap-2 mb-3 mt-3" style={{ direction: 'ltr' }}>
                    {otp.map((digit, index) => (
                        <Form.Control
                            key={index}
                            type="text"
                            maxLength="1"
                            value={digit}
                            onChange={(e) => handleOtpChange(index, e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Backspace" && !otp[index] && index > 0) {
                                    inputRefs.current[index - 1]?.focus();
                                }
                            }}
                            className="text-center otp-input number-font"
                            style={{ width: "40px", fontSize: "1.5rem" }}
                            ref={(el) => (inputRefs.current[index] = el)}
                        />
                    ))}
                </div>

                <button disabled={resendBtn} className='btn mt-2 text-[#00a14b] text-center w-100 border-0 d-flex align-items-center justify-content-center gap-2 number' style={{ color: '#00a14b' }} onClick={(e) => checkMobileFun(e)}>
                    {resendCode ? 'ارسال مجدد' : formatTime(time)} {loader && <Loader />} </button>
                <button
                    onClick={(e) => checkOtp()}
                    disabled={loader}
                    className="btn btn-primary btn-login mx-auto mt-3 d-flex align-items-center gap-2 justify-center"
                >
                    تایید و ثبت نام {checkOtpLoading && <Loader />}
                </button>


            </Dialog>
        </>

    );
};

export default Login;
